
import { useEffect, useRef, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { getItemSessionStorage } from "../../../features/webStorageSaver";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { countExtentFromGeoJSONFeatures } from "../../../widgets/map/mapFeatures/helpers";
import { getGeoJSONFeaturesVectorLayer, getAllRoadObjectsLayer } from "../../../widgets/map/mapFeatures/layers";
import MapWidget from "../../../widgets/map/mapWidget/MapWidget";
import { setPrintButtonIsClicked } from "../../../stateManagement/reducers/ContentHeaderSlice";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";

export function RegionInfoCard() {
    const { regionId } = useParams()
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [name, setName] = useState<any>()
    const [contentHeaderType, setContentHeaderType] = useState<any>()
    const [additionalLayers, setAdditionalLayers] = useState<any>([])
    const [fitExtent, setFitExtent] = useState<any>();
    const [fitExtentPadding, setFitExtentPadding] = useState<any>([]);
    const [mapState, setMapState] = useState<any>(null)
    const [printMapState, setPrintMapState] = useState<any>(null)
    const [mapEventHandlers, setMapEventHandlers] = useState<any>()
    const [permanentLayersMap] = useState([getAllRoadObjectsLayer()])
    const [permanentLayersPrintMap] = useState([getAllRoadObjectsLayer()])

    const currentRegions = getItemSessionStorage('featuresOnMapPoint')?.regionFeatures
    const currentRegion = currentRegions?.filter((item: any) => item.id === 'Region.' + regionId)[0]
    // флаг - индикация нажатия кнопки печати
    const printButtonIsClicked = useAppSelector(state => state.contentHeader.printButtonIsClicked)
    const printRef = useRef(null);
    // функция печати страницы информации
    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        documentTitle: 'IndorGeo ' + `- ${currentRegion?.properties.NAME}`,
        pageStyle: 'print'
    });

    // обработчик изменения флага-индикации нажатия кнопки печати
    if (printButtonIsClicked && currentRegion) {
        setTimeout(() => { handlePrint() }, 2000)
        dispatch(setPrintButtonIsClicked(false))
    }

    useEffect(() => {
        if (currentRegion) {
            setContentHeaderType('card')
            setName(currentRegion?.properties.NAME)
            const regionLayer = getGeoJSONFeaturesVectorLayer(currentRegion, "EPSG:4326")
            setAdditionalLayers([regionLayer])
            const extent = countExtentFromGeoJSONFeatures(currentRegion)
            setFitExtent(extent)
            setFitExtentPadding([50, 50, 50, 50])
        } else {
            setName('Регион')
        }
    }, [])

    useEffect(() => {
        function applySynchronizePrintMap(map: any) {
            const synchFunc = (event: any) => {
                if (mapState && printMapState) {
                    printMapState.getView().fit(mapState.getView().calculateExtent(), {
                        size: printMapState.getSize()
                    });
                }
            }
            map?.on("moveend", synchFunc)
            return {
                off: () => {
                    map?.un("moveend", synchFunc)
                }
            }
        }
        setMapEventHandlers(
            [
                {
                    name: "synchronizePrintMap",
                    func: applySynchronizePrintMap
                }
            ]
        )
    }, [mapState, printMapState])

    return (
        <>
            <ContentHeader title={name} type={contentHeaderType} option="region" />
            <div className="federal-road-info-card-div" ref={printRef}>
                {currentRegion
                    ?
                    <div className="federal-road-info-card-div">
                        <Row>
                            <div className="section-name">Информация о регионе</div>
                            <Col>
                                <div className="federalChoosingText">
                                    <span>Название: {currentRegion.properties.NAME}</span>
                                </div>
                            </Col>
                        </Row>
                        <div className="map-widget-federal-road-info">
                            <MapWidget
                                mapStateReturnFunc={(map: any) => setMapState(map)}
                                additionalLayers={additionalLayers}
                                permanentLayers={permanentLayersMap}
                                propsFitExtent={fitExtent}
                                propsFitExtentPadding={fitExtentPadding}
                                mapEventHandlers={mapEventHandlers}
                                mapInfoWidgetIsShown={false}
                                propsMinZoom={4}
                            />
                        </div>
                        <div className="map-to-print-div">
                            <div className="page-break" />
                            <MapWidget
                                target="federal-road-info-map-print"
                                mapStateReturnFunc={(map: any) => setPrintMapState(map)}
                                additionalLayers={additionalLayers}
                                permanentLayers={permanentLayersPrintMap}
                                propsFitExtent={fitExtent}
                                propsFitExtentPadding={fitExtentPadding}
                                mapSizeClass="federal-road-info-map-print"
                                mapInfoWidgetIsShown={false}
                                showMapLoader={false}
                                propsMinZoom={3}
                            />
                        </div>
                    </div>
                    :
                    <div className="no-federal-road-info">
                        <Row>
                            <div className="section-name">Информация о регионе</div>
                            <div className="no-federal-road-text">
                                <span>Нет данных по региону, выберите на карте:</span>
                            </div>
                            <Col>
                                <Button className="table-object-info-document-but on-map-but" onClick={() => navigate(`/app/map/AllRoadObjects`)}>
                                    Открыть карту
                                </Button>
                            </Col>
                        </Row>
                    </div>
                }
            </div>
        </>
    )
}
